
import { motion } from 'framer-motion';

const ValueSection = () => {
  const values = [
    {
      icon: 'ri-file-check-line',
      title: '无票出口合规化',
      description: '解决中小企业无法取得增值税发票的难题，通过市场采购贸易方式实现合法合规出口，享受国家政策支持，免征不退税政策让出口更简单。',
      gradient: 'from-blue-500 to-blue-600',
    },
    {
      icon: 'ri-stack-line',
      title: '多品类集拼优势',
      description: '支持多品种、小批量、多批次的商品集拼出口，单票报关单商品货值最高15万美元，适合跨境电商、外贸综合服务企业等多种业态。',
      gradient: 'from-accent to-accent-dark',
    },
    {
      icon: 'ri-exchange-dollar-line',
      title: '快速结汇通道',
      description: '简化外汇收支手续，支持人民币结算，资金回笼快速便捷。通过数字化系统实现秒级结汇，大幅提升资金周转效率，降低汇率风险。',
      gradient: 'from-green-500 to-green-600',
    },
  ];

  return (
    <section className="py-24 bg-neutral-100">
      <div className="max-w-[1440px] mx-auto px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="inline-flex items-center gap-2 mb-4">
            <div className="w-3 h-3 bg-primary rotate-45"></div>
            <span className="text-primary text-sm font-semibold uppercase tracking-wider whitespace-nowrap">核心价值</span>
          </div>
          <h2 className="text-4xl font-bold text-primary mb-4">
            1039为什么能解决出口难题
          </h2>
          <p className="text-neutral-500 text-lg max-w-2xl mx-auto">
            国家级政策支持，为中小企业量身定制的出口解决方案
          </p>
        </motion.div>

        {/* Value Cards */}
        <div className="grid grid-cols-3 gap-8">
          {values.map((value, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              whileHover={{ y: -8, transition: { duration: 0.3 } }}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer"
            >
              {/* Icon */}
              <div className={`w-20 h-20 rounded-full bg-gradient-to-br ${value.gradient} flex items-center justify-center mb-6`}>
                <i className={`${value.icon} text-4xl text-white`}></i>
              </div>

              {/* Title */}
              <h3 className="text-2xl font-bold text-primary mb-4">{value.title}</h3>

              {/* Divider */}
              <div className="w-16 h-1 bg-accent mb-6"></div>

              {/* Description */}
              <p className="text-neutral-500 leading-relaxed mb-6">
                {value.description}
              </p>

              {/* Link */}
              <a href="#" className="inline-flex items-center gap-2 text-primary font-semibold hover:text-accent transition-colors cursor-pointer whitespace-nowrap">
                了解详情
                <i className="ri-arrow-right-line"></i>
              </a>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValueSection;
